import {formatMoneyBig} from "@Common/ui-components/language/format-money";

export const formatFlexMoney = (amount) => {
    if (amount == null) {
        return "N/A";
    }
    if (typeof amount === "object") {
        return formatMoneyBig(amount.numberInt);
    }
    return formatMoneyBig(amount);
};
